export enum ErrorTypeEnum {
    /** token 失效 */
    LOGIN_OVERDUE = 103,
    /** 账号注销 */
    LOG_OUT = 403,
}
